import {
  getDicTab
} from "@/utils/config";
export default {
  inserted: async function (el, binding, vnode) {
    const {
      value
    } = binding
    el.innerHTML = await getDicTab(value[0], value[1])
  },
  update:async function (el, binding, vnode) {
    const {
      value
    } = binding
    el.innerHTML = await getDicTab(value[0], value[1])
  },
}



// WEBPACK FOOTER //
// ./src/directive/dict/dict.js